import React from "react";
import ReactDOM from "react-dom";
import CommentEditor from "../Components/CommentEditor/CommentEditor";
import { Subtract } from "utility-types";

type RenderProps = {
    comments: Comments[];
    el: Element;
    delete: (id: string) => any;
    add: (comment: string) => any;
    right?: string;
    top?: string;
};

export type Comments = {
    id: string;
    comment: string;
    comment_type: string;
    user_name: string;
    user_intent: string;
    user_id: number;
    replies: any[];
    created_at: Date;
    updated_at: Date;
};

export type CommentProps = {
    renderNote: (render: RenderProps) => void;
};

export function mapToComments(data: any): Comments {
    return {
        ...data,
        created_at: new Date(data.created_at),
        updated_at: new Date(data.updated_at),
    };
}

export default function withComments<P extends CommentProps>(
    WrappedComponent: React.ComponentType<P>
): React.FC<Subtract<P, CommentProps>> {
    return (props) => {
        const getNoteEditor = (render: RenderProps) => {
            let note = document.getElementById("reader-comment");
            if (!note) {
                note = document.createElement("div");
                note.id = "reader-comment";
                note.style.position = "absolute";
                note.style.right = render.right ?? "-120px";
                note.style.top = render.top ?? "-190px";
                note.style.zIndex = "100";
                note.style.margin = "0px";
                render.el.insertAdjacentElement("beforeend", note);
                ReactDOM.render(
                    <CommentEditor
                        comments={render.comments}
                        onDelete={render.delete}
                        onAdd={render.add}
                        leftPointer={(render.el as HTMLElement).offsetLeft}
                        onCancel={() => note?.parentElement?.removeChild(note)}
                    />,
                    note
                );
            } else {
                note.parentElement?.removeChild(note);
            }
        };
        return (
            <WrappedComponent {...(props as P)} renderNote={getNoteEditor} />
        );
    };
}
